



import { useState, useEffect } from 'react';

const StatsSection = ({ metrics = [], loading = false }) => {
  const fallbackStats = [
    { value: "40+", label: "Countries" },
    { value: "1200+", label: "Registered Vendors" },
    { value: "1,26,000+", label: "Items Shipped" },
    { value: "2000+", label: "Customers" },
  ];

  const [statsData, setStatsData] = useState(fallbackStats);

  // Use Firestore metrics if available, otherwise use fallback
  useEffect(() => {
    try {
      if (metrics && Array.isArray(metrics) && metrics.length > 0) {
        console.log('Using Firestore metrics:', metrics);
        setStatsData(metrics);
      } else {
        console.log('Using fallback metrics (no Firestore data)');
        setStatsData(fallbackStats);
      }
    } catch (err) {
      console.error('Error setting stats data:', err);
      setStatsData(fallbackStats);
    }
  }, [metrics]);

  return (
    <div className="relative z-10 w-full bg-black">
      <div className="max-w-[1440px] mx-auto py-10 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-6 xl:gap-x-96 lg:gap-x-60 text-center">
          {statsData.map((stat, index) => (
            <div key={index} className="flex flex-col items-center justify-evenly">
              <span className="text-3xl md:text-4xl font-medium text-white mb-1">
                {stat.title}
              </span>
              <span className="text-sm md:text-base text-gray-200 font-normal">
                {stat.subtitle}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  
  );
};

export default StatsSection;
